import { isJSON } from "@/util/utils";
import { platformInspectionTypeLabel } from "@/util/platformInspectionType";

/** 商品图：支持 JSON { img, packImg } 或单 URL */
export function productImageUrls(row) {
  if (!row || !row.productImage) return [];
  const raw = row.productImage;
  if (typeof raw === "string" && isJSON(raw)) {
    try {
      const obj = JSON.parse(raw);
      const urls = [];
      if (obj && obj.img) urls.push(obj.img);
      if (obj && obj.packImg) urls.push(obj.packImg);
      return urls;
    } catch (e) {
      return [];
    }
  }
  if (typeof raw === "string" && (raw.indexOf("http") === 0 || raw.indexOf("/") === 0)) {
    return [raw];
  }
  return [];
}

export function brandDisplay(row) {
  if (!row) return "";
  const cn = row.brandName || (row.brand && row.brand.name) || "";
  const en = row.brandEnglishName || (row.brand && row.brand.englishName) || "";
  if (cn && en) return cn + " - " + en;
  return cn || en || "";
}

export function typeDisplay(row) {
  if (!row) return "";
  const cn = row.typeName || (row.type && row.type.name) || "";
  const en = row.typeEnglishName || (row.type && row.type.englishName) || "";
  if (cn && en) return cn + " - " + en;
  return cn || en || "";
}

/** 实物图 / 瑕疵图 JSON 解析为 URL 数组 */
export function parsePictureUrls(raw) {
  if (!raw) return [];
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!parsed) return [];
    if (Array.isArray(parsed)) return parsed.filter(Boolean);
    if (typeof parsed === "object") return Object.values(parsed).filter((v) => v);
  } catch (e) {
    /* ignore */
  }
  return [];
}

export function formatInspectionDateTime(val) {
  if (!val) return "-";
  const d = new Date(val);
  if (isNaN(d.getTime())) {
    if (typeof val === "string") return val.substring(0, 19);
    return val;
  }
  const pad = (n) => (n < 10 ? "0" + n : n);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export function sffzLabel(sffz) {
  if (sffz == null || sffz === "") return "-";
  return Number(sffz) === 1 ? "不分装" : "分装";
}

export function specificationMl(spec) {
  if (!spec) return "";
  try {
    const obj = typeof spec === "string" ? JSON.parse(spec) : spec;
    return obj && obj.ml ? obj.ml + "ml" : "";
  } catch (e) {
    return "";
  }
}

export { platformInspectionTypeLabel };



// WEBPACK FOOTER //
// ./src/util/inspectionJobDisplay.js